// extracted by mini-css-extract-plugin
module.exports = {"productWrapper":"styles_productWrapper__26rHA","product":"styles_product__3rmzq"};